<template>
  <div>

    <!-- Settings -->
    <el-row :gutter="8">
      <el-col :span="24" :md="12">
        <!-- Date-range picker & shop finder -->
        <el-card shadow="never">
          <ShopFinder :user-type="userType" @shop-selected="onShopSelected"></ShopFinder>

          <el-date-picker v-model="dates" type="daterange" range-separator="～"
            start-placeholder="開始日期" end-placeholder="結束日期"
            :picker-options="pickerOptions" @change="onDateRangePicked">
          </el-date-picker>
        </el-card>
      </el-col>

      <el-col :span="24" :md="12">
        <!-- Date-range picker & shop finder -->
        <el-card shadow="never">
          <el-button type="danger" round icon="el-icon-download" :disabled="!shopId"
            @click="downloadVoucherLists">
            匯出餐券與兌換記錄
          </el-button>
          <el-button type="warning" round icon="el-icon-download" :disabled="userType != 'gaa' && !shopId"
            @click="downloadLogs">
            匯出核銷與反核銷記錄
          </el-button>
        </el-card>
      </el-col>
    </el-row>

    <br>

    <!-- Main figures -->
    <el-row :gutter="8" v-show="shopId">

      <!-- Simple Stats about vouchers -->
      <el-col :span="24" :md="6">
        
        <stats-card :class="{'selected': expansion.vouchers.show}"
          type="info"
          :title="`${stats.count.soldVoucherSets}`"
          subTitle="售出餐券組訂單數"
          icon="now-ui-icons shopping_bag-16">
          <span slot="footer">
            <i class="el-icon-coffee"></i>
            總共包含 {{ stats.count.soldVouchers }} 張餐券
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="primary" plain size="mini" @click="expandVoucherList">
              查看列表
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </span>
        </stats-card>

        <stats-card :class="{'selected': expansion.redemptions.show}"
          type="warning"
          :title="`${stats.count.redeemedVouchers}`"
          subTitle="兌換餐券數"
          icon="el-icon-coffee">
          <span slot="footer">
            <i class="now-ui-icons files_paper"></i>
            使用了餐券的訂單數：{{ stats.count.distinctOrders }}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="primary" plain size="mini" @click="expandRedemptionList">
              查看列表
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </span>
        </stats-card>

      </el-col>

      <transition name="el-zoom-in-top">
        <el-col :span="24" :md="18" v-show="expansion.vouchers.show">
          <el-card>
            <h4>餐券售出列表 | {{ shopName }}</h4>
            <SSRTable :data-url="urlGetVouchers" :schema="schema.vouchers"
              data-key="vouchers">
              <div slot="amount" slot-scope="{row}">
                ${{ Number(row.amount).toLocaleString() }}
              </div>
              <div slot="coupon_status" slot-scope="{row}">
                {{ row.coupon_status === '1'? '是': '否' }}
              </div>
            </SSRTable>
          </el-card>
        </el-col>
      </transition>

      <transition name="el-zoom-in-top">
        <el-col :span="24" :md="18" v-show="expansion.redemptions.show">
          <el-card>
            <h4>兌換記錄 | {{ shopName }}</h4>
            <SSRTable :data-url="urlGetRedemptions"
              :schema="schema.redemptions" data-key="redemptions"
              @server-response="updateRedemptionStats">
              <div slot="amount" slot-scope="{row}">
                ${{ Number(row.amount).toLocaleString() }}
              </div>
              <div slot="unit_price" slot-scope="{row}">
                ${{ Number(row.unit_price).toLocaleString() }}
              </div>
              <div slot="qty" slot-scope="{row}">
                ${{ Number(row.qty).toLocaleString() }}
              </div>
              <div slot="subtotal" slot-scope="{row}">
                ${{ Number(row.unit_price * row.qty).toLocaleString() }}
              </div>
            </SSRTable>
          </el-card>
        </el-col>
      </transition>

    </el-row>

  </div>
</template>

<script>
import StatsCard from 'src/components/Cards/StatsCard'
import ShopFinder from 'src/components/ShopFinder';
import SSRTable from 'src/components/SSRTable';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    StatsCard,
    ShopFinder,
    SSRTable
  },

  mounted() {
    
  },

  methods: {
    fetchVoucherStats() {
      if (!this.shopId) return;
      let from = moment(this.dates[0]).startOf('day');
      let to = moment(this.dates[1]).endOf('day');
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}/vouchers/stats`
        + `?from=${from.unix()}&to=${to.unix()}`
      )
      .then(response => {
        // console.log(response.data);
        this.stats.count.soldVoucherSets = response.data['count']['soldVoucherSets'];
        this.stats.count.soldVouchers = response.data['count']['soldVouchers'];
        this.stats.count.soldVouchersUsed = response.data['count']['soldVouchersUsed'];
        this.stats.count.redeemedVouchers = response.data['count']['redeemedVouchers'];
        this.stats.count.distinctOrders = response.data['count']['distinctOrders'];
      })
      .catch(err => {
        console.error(`Cannot fecth voucher statistics.`, err);
        //TODO: Show error alert.
      });
    },
    downloadVoucherLists() {
      if (!this.shopId) return;
      let from = moment(this.dates[0]).startOf('day');
      let to = moment(this.dates[1]).endOf('day');
      if (to.diff(from, 'days') > 31) {
        alert(`匯出日期區間最多一個月（31日）!`);
        return;
      }
      window.open(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}`
        + `/vouchers/export`
        + `?from=${from.unix()}&to=${to.unix()}&shopName=${this.shopName}` 
      );
    },
    downloadLogs() {
      if (this.userType !== 'gaa' && !this.shopId) return;

      let from = moment(this.dates[0]).startOf('day');
      let to = moment(this.dates[1]).endOf('day');
      
      //FIXME: 限制只能在當月8日後匯出前月的記錄
      let lastAllowedMoment;
      if (moment().isAfter(moment().startOf('month').add(7, 'days')))
        lastAllowedMoment = moment().add(-1, 'month').endOf('month');
      else
        lastAllowedMoment = moment().add(-2, 'month').endOf('month');
      if (this.userType != 'gaa' && to.isAfter(lastAllowedMoment)) {
        alert(`每個月8日以後才能匯出前月的記錄。`);
        return;
      }
      if (to.diff(from, 'days') > 31) {
        alert(`匯出日期區間最多一個月（31日）!`);
        return;
      }

      if (this.userType == 'gaa' && !this.shopId) {//Download logs of all
        window.open(
          `${process.env.VUE_APP_APIHOST}/${this.userType}`
          + `/vouchers/logs`
          + `?from=${from.unix()}&to=${to.unix()}` 
        );
      }
      else {//Download logs of a specified shop.
        window.open(
          `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}`
          + `/vouchers/logs`
          + `?from=${from.unix()}&to=${to.unix()}&shopName=${this.shopName}` 
        );
      }
      
    },

    onDateRangePicked() {
      this.fetchVoucherStats();
    },
    onShopSelected(shopId, shopName) {
      this.shopId = shopId;
      this.shopName = shopName;
      this.fetchVoucherStats();
    },

    updateRedemptionStats(data) {
      // this.stats.count.redeemedvouchers = data.total;
    },

    expandVoucherList() {
      if (this.expansion.vouchers.show === true) return;
      this.expansion.redemptions.show = false;
      setTimeout(() => {
        this.expansion.vouchers.show = true;
      }, 500);
    },
    expandRedemptionList() {
      if (this.expansion.redemptions.show === true) return;
      this.expansion.vouchers.show = false;
      setTimeout(() => {
        this.expansion.redemptions.show = true;
      }, 500);
    }
  },

  data() {
    return {
      dates: [
        moment().startOf('month').toDate(),
        moment().endOf('day').toDate()
      ],
      shopId: null,
      shopName: null,

      stats: {
        count: {
          soldVoucherSets: 0,
          soldVouchers: 0,
          soldVouchersUsed: 0,
          redeemedVouchers: 0,
          distinctOrders: 0
        }
      },

      /// Dialogs & Expansions
      expansion: {
        vouchers: {
          show: true
        },
        redemptions: {
          show: false
        }
      },

      /// Tables' schemas
      schema: {
        vouchers: [
          { key: 'product_name', label: '餐券' },
          { key: 'amount', label: '價格', align: 'right', width: 120  },
          { key: 'created_at', label: '購買時間' },
          { key: 'using_end_time', label: '有效期限' },
          { key: 'dotdot_prod_name', label: '可兌換品項' },
          { key: 'coupon_status', label: '已兌換？' },
        ],
        redemptions: [
          { key: 'order_id', label: '訂單ID' },
          { key: 'created_at', label: '下單時間' },
          { key: 'amount', label: '訂單金額', align: 'right', width: 120 },
          { key: 'product_name', label: '兌換品項' },
          { key: 'unit_price', label: '單價', align: 'right', width: 96 },
          { key: 'qty', label: '數量', align: 'right', width: 84 },
          { key: 'subtotal', label: '小計',  align: 'right', width: 120},
          { key: 'ticket_order_no', label: '餐券訂單編號' },
        ]
      },

      /// Date-range picker options
      pickerOptions: {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              let d = moment().add(-1, 'days');
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          },
          {
            text: '今日',
            onClick(picker) {
              let d = moment();
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          }
        ]
      }
    };
  },

  computed: {
    userType() {
      return this.$store.getters.userType;
    },

    urlGetVouchers() {
      if (!this.shopId) return null;
      let from = moment(this.dates[0]).startOf('day');
      let to = moment(this.dates[1]).endOf('day');
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}/vouchers`
        + `?from=${from.unix()}&to=${to.unix()}`;
    },
    urlGetRedemptions() {
      if (!this.shopId) return null;
      let from = moment(this.dates[0]).startOf('day');
      let to = moment(this.dates[1]).endOf('day');
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}/vouchers/redemptions`
        + `?from=${from.unix()}&to=${to.unix()}`;
    }
  },

}
</script>

<style scoped>
.card-stats.selected {
  background: #BBDEFB;
}
</style>